module.exports = __webpack_public_path__ + "static/img/home_1.c3ef0f77.svg";